import { render } from "./content.vue?vue&type=template&id=53860f44&scoped=true&ts=true"
import script from "./content.vue?vue&type=script&lang=ts"
export * from "./content.vue?vue&type=script&lang=ts"

import "./content.vue?vue&type=style&index=0&id=53860f44&lang=less&scoped=true"

import exportComponent from "/home/npm/produce/project/yuanYaExam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53860f44"]])

export default __exports__